import * as React from 'react'
import { ReactElement } from 'react'
import { Country } from '../../../config/i18nConfig'
import useCountries from '../../../hooks/useCountries'
import I18NCombobox, { I18NComboboxProps } from './I18NCombobox'

export type CountryComboboxProps = Omit<I18NComboboxProps<Country>, 'entities' | 'idKey'>

export default function CountryCombobox(props: CountryComboboxProps): ReactElement {
    const { countries } = useCountries()

    return (
        <I18NCombobox<Country>
            entities={countries}
            idKey={'alpha2'}
            placeholderKey={'base.countrycombobox.placeholder'}
            {...props}
        />
    )
}
